var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BTN_-_HIDE",
    "data-name": "BTN - HIDE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HIDE"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "visibility_off_FILL1_wght400_GRAD0_opsz48",
    d: "M15.486,15.783,13.1,13.4a2.44,2.44,0,0,0,.286-.693,3.23,3.23,0,0,0,.1-.8A3.123,3.123,0,0,0,10.35,8.763a3.418,3.418,0,0,0-.794.092,2.233,2.233,0,0,0-.7.3L6.821,7.1a8.378,8.378,0,0,1,1.654-.517,9.136,9.136,0,0,1,1.968-.222,8.282,8.282,0,0,1,4.6,1.367A8.868,8.868,0,0,1,18.258,11.4a.589.589,0,0,1,.074.222,1.962,1.962,0,0,1,.018.277,2.166,2.166,0,0,1-.018.286.6.6,0,0,1-.074.231,8.867,8.867,0,0,1-1.182,1.866A8.709,8.709,0,0,1,15.486,15.783Zm.665,3.769-2.7-2.642a7.178,7.178,0,0,1-1.46.4,9.768,9.768,0,0,1-1.644.139,8.463,8.463,0,0,1-4.674-1.367A8.825,8.825,0,0,1,2.442,12.4a.778.778,0,0,1-.074-.231A1.771,1.771,0,0,1,2.35,11.9a1.457,1.457,0,0,1,.028-.286,1.339,1.339,0,0,1,.065-.231A8.764,8.764,0,0,1,3.431,9.77,9.984,9.984,0,0,1,4.844,8.282L2.9,6.342a.536.536,0,0,1,0-.776.558.558,0,0,1,.794,0L16.927,18.795a.49.49,0,0,1,.148.36.554.554,0,0,1-.148.379.464.464,0,0,1-.379.185.542.542,0,0,1-.4-.166Zm-5.8-4.508A3.6,3.6,0,0,0,10.9,15a1.934,1.934,0,0,0,.5-.139L7.394,10.85a2.262,2.262,0,0,0-.139.5,3.366,3.366,0,0,0-.046.554,3.006,3.006,0,0,0,.924,2.236A3.055,3.055,0,0,0,10.35,15.044Zm1.94-2.457L9.666,9.964a1.974,1.974,0,0,1,2.125.443A1.833,1.833,0,0,1,12.29,12.587Z",
    transform: "translate(1.65 -0.4)",
    opacity: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.f8086a0dd62bc5f59466494581fe361b.svg";
export { ForwardRef as ReactComponent };